<template>
	<div class="codes">
		<!-- <div v-if="$store.state.needWeChatCode" class="wechat_logo">
			<img class="codes_logo" src="@/assets/images/banner/weChat_logo.png" />
			<span>
				<img src="@/assets/images/banner/weChat_code.png" />
			</span>
		</div>
		<div v-if="$store.state.showAppCode" class="app_logo">
			<img class="codes_logo" src="@/assets/images/banner/app_logo.png" />
			<span>
				<img src="@/assets/images/banner/app_code.png" />
			</span>
		</div> -->
	</div>
</template>

<script>
	export default {
		data() {
	  		return {
	  			
	  		}
	  	},
	}
</script>

<style scoped="scoped">
	.codes {
		position: fixed;
		right: 10px;
		top: 50%;
		z-index: 999999;
	}
	.codes>div {
		position: relative;
		margin-top: 10px;
		cursor: pointer;
	}
	.codes span {
		visibility:hidden;
		opacity: 0;
		position: absolute;
	    right: 50px;
	    top: -55px;
	    z-index: 999999;
	    transform: translateY(20px);
	    transition: .2s linear;
	}
	.codes>div:hover span {
		visibility: visible;
		transform: translateY(0);
		opacity: 1;
	}
</style>


// WEBPACK FOOTER //
// src/components/public/code.vue